export default "__VITE_ASSET__rec6rAAH__"